import React, { useState } from 'react';
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
  Tabs,
  Tab,
  Container
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Person as PersonIcon, Psychology as PsychologyIcon } from '@mui/icons-material';
import { pacientesIniciais } from '../shared/initialData';

// Estilos com a identidade visual do site
const LoginContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(5),
  maxWidth: 550,
  margin: '80px auto',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  borderRadius: 16,
  backgroundColor: '#fff'
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  borderRadius: 8,
  backgroundColor: 'rgba(90, 154, 148, 0.08)',
  '& .MuiTabs-indicator': {
    backgroundColor: '#5a9a94',
  }
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.9rem',
  textTransform: 'none',
  minHeight: 48,
  '&.Mui-selected': {
    color: '#5a9a94',
    fontWeight: 700,
  },
  '&:hover': {
    color: '#5a9a94',
    opacity: 0.8,
  }
}));

const FormField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#5a9a94',
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#5a9a94',
    },
    '&:hover fieldset': {
      borderColor: '#84b59f',
    }
  },
});

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setEmail('');
    setPassword('');
    setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Preencha todos os campos');
      return;
    }

    if (activeTab === 0) {
      if (email === 'admin@exemplo.com' && password === 'senha123') {
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('userType', 'psicologo');
        localStorage.setItem('userId', '1');
        localStorage.setItem('email', 'admin@exemplo.com');
        window.location.href = '/psicologo';
      } else if (email === 'joao.silva@exemplo.com' && password === 'senha123') {
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('userType', 'psicologo');
        localStorage.setItem('userId', '2');
        localStorage.setItem('email', 'joao.silva@exemplo.com');
        window.location.href = '/psicologo';
      } else {
        setError('Email ou senha inválidos');
      }
    } else {
      // Verificar pacientes cadastrados
      const pacienteEncontrado = pacientesIniciais.find(
        p => p.email === email && p.senha === password
      );
      
      if (pacienteEncontrado) {
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('userType', 'paciente');
        localStorage.setItem('userId', pacienteEncontrado.id.toString());
        localStorage.setItem('email', pacienteEncontrado.email);
        window.location.href = '/paciente';
      } else if (email === 'paciente@exemplo.com' && password === 'senha123') {
        // Manter a opção de login de demonstração
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('userType', 'paciente');
        localStorage.setItem('userId', '1');
        localStorage.setItem('email', 'paciente@exemplo.com');
        window.location.href = '/paciente';
      } else {
        setError('Email ou senha inválidos');
      }
    }
  };

  return (
    <Container component="main" maxWidth="md" sx={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center',
      py: 4,
      backgroundImage: 'radial-gradient(circle at 70% 50%, rgba(132, 181, 159, 0.1) 0%, rgba(90, 154, 148, 0.05) 50%)'
    }}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        mb: 4 
      }}>
        <Typography 
          variant="h3" 
          component="h1" 
          sx={{ 
            fontWeight: 700, 
            mb: 2,
            background: 'linear-gradient(135deg, #5a9a94 0%, #84b59f 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: '-0.5px'
          }}
        >
          Acesso ao Sistema
        </Typography>
        <Typography variant="body1" sx={{ color: '#666' }}>
          Faça login para acessar a sua conta
        </Typography>
      </Box>
      
      <LoginContainer>
        <StyledTabs 
          value={activeTab} 
          onChange={handleTabChange} 
          variant="fullWidth"
          textColor="inherit"
        >
          <StyledTab 
            icon={<PsychologyIcon />} 
            iconPosition="start" 
            label="Psicólogo" 
            id="tab-psicologo"
            aria-controls="tabpanel-psicologo"
          />
          <StyledTab 
            icon={<PersonIcon />} 
            iconPosition="start" 
            label="Paciente" 
            id="tab-paciente"
            aria-controls="tabpanel-paciente"
          />
        </StyledTabs>
        
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        
        <Box
          role="tabpanel"
          id={`tabpanel-${activeTab === 0 ? 'psicologo' : 'paciente'}`}
          aria-labelledby={`tab-${activeTab === 0 ? 'psicologo' : 'paciente'}`}
        >
          <form onSubmit={handleSubmit}>
            <FormField
              label="Email"
              type="email"
              fullWidth
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={activeTab === 0 ? "email@clinica.com" : "paciente@email.com"}
              variant="outlined"
            />
            
            <FormField
              label="Senha"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
            />
            
            <Button 
              type="submit"
              variant="contained" 
              fullWidth
              sx={{ 
                mt: 4, 
                mb: 2,
                py: 1.5,
                backgroundColor: '#5a9a94',
                '&:hover': {
                  backgroundColor: '#4a8a84',
                },
                fontWeight: 600,
                borderRadius: '8px',
                boxShadow: '0 4px 10px rgba(74, 138, 132, 0.2)'
              }}
            >
              Entrar
            </Button>
          </form>
          
          <Typography variant="body2" align="center" sx={{ mt: 3, color: '#666' }}>
            <strong>Contas para teste:</strong><br/>
            {activeTab === 0 ? (
              <>Psicólogo: admin@exemplo.com / senha123<br/>
              Outro psicólogo: joao.silva@exemplo.com / senha123</>
            ) : (
              <>Paciente: paciente@exemplo.com / senha123</>
            )}
          </Typography>
        </Box>
      </LoginContainer>
    </Container>
  );
};

export default Login; 